export default {"src":"/_next/static/media/ship-sticks-dark.2874b9dc.svg","height":522,"width":1063,"blurWidth":0,"blurHeight":0};